import { Heading } from '@chakra-ui/react';
import React from 'react';

export const PreviewLetterStyle = {

  variants: {
    wrapper: {
      '.previewWrapper': {
        display:"flex",
        justifyContent:"space-between",
      },
      '.actionWrapper': {
        width: '28%',
      },
      '.sectionWrapper': {
        width: "70%",
        backgroundColor: '#F7F7FA',
        padding: '.5rem 1rem',
        borderRadius: '10px',
        border: '1px solid #333',
      },
      section: {
        '.sections': {
        },
        '.mainBox': {
          position: 'relative',
          backgroundColor: '#F7F7FA',
          padding: '.5rem 0 0 0',
          marginBottom: '1rem',
          width: '100%',
          '.contentBox': {
            width: '100%',
            paddingLeft:'.5rem',
          },

          '.subSections': {
            padding: '.5rem 0',
            width: '100%',
            borderBottom: '1px solid #333',
            _last: { borderBottom: 'none' },
          },
          '.subSectionsInterior': {
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'nowrap',
          },
          '.subSection': {
            display: 'flex',
          },
          '.alignRight': {
            textAlign: 'right',
          },
          /**Expertise**/
          '.expertise': {
            display: 'flex',
            justifyContent: 'center',
            flexWrap:'wrap',
            maxWidth:'70%',
            margin:'0 auto',
          },
          '.skill': {
            display: 'inline',
            borderRight: '1px solid #333',
            padding: '0 .4rem',
            textWrap:'nowrap',
            _last: { borderRight: 'none' },
          },
          /**Professional Experience**/

          '.bulletsWrap': {
            display: 'flex',
            width: '100%',
            flexWrap: 'nowrap',
            marginLeft: '-15px',
          },
          '.bulletIcon': {
            paddingTop: '.5rem',
            paddingLeft: '1rem',
            marginRight: '.5rem',
            fontSize: '.5rem',
          },
          '.jobTitleWrapper': {
            marginTop: '.2rem',
          },
          '.jobTitle': {
            fontSize: '15px',
            display: 'inline',
          },
          '.startDate': {
            textAlign: 'right',
            display: 'inline'
          },
          '.endDate': {
            marginLeft:'.4rem',
            display: 'inline',
          },
          /**Computer Skills**/

          '.computerSkills': {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
            width: '100%',
            paddingTop:'.5rem',
          },
          '.techSkills': {
            marginRight: '.4rem',
          },
          '.csContentBox': {
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-start',
            flexWrap: 'wrap',
          },
          '.comma': {
            display: 'inline',
            marginRight: '.3rem',
            _last: { display: 'none' },
          },
          /**END Computer Skills**/
          /**Contact**/
          '.contact': {
            /*
            display: 'flex',
            justifyContent: 'space-between',

             */
            '.header': {
              marginTop: '1rem',
              '.names': {
                'fontSize': '2.8rem',
              },
            },
          },
          '.infoWrapper': {
            position: 'relative',
            paddingBottom: '1.5rem',
            '.linkWrapper': {
              display: 'flex',
              flexWrap: 'nowrap',
              marginTop: '.3rem',
            },
            '.letterBody': {
              maxWidth: '100%',
              textWrap: 'auto'
            },

            '.linkText': {
              fontWeight: 'bold',
              display: 'inline',
              padding: '.2rem',
              marginRight: '.5rem',
              color: 'white',
              backgroundColor: '#ff914D',
              borderRadius: '50%',
              '.link': {
                color: 'red',
              },
            },
          },
          '.contactEditButtonWrap': {
            marginBottom:'1.3rem',
          },
          /** END Contact**/
        },

      },
      accordion: {
        '.name': {
          fontWeight: 'bold',
          fontSize: '20px',
        },
        '.sectionTitle': {
          padding: '.2rem 0 .2rem .5rem',
          backgroundColor: '#D7DDE8',
          color: '#000',
          textTransform: 'uppercase',
          fontSize: '20px',
          marginTop: '5px',
          marginBottom: '8px',
          textAlign: 'left',
        },
        '.divider': {
          display: 'inline',
          margin:'0 .4rem',
        },
        '.accordion': {
          margin: '0 0 1rem 0',
        },
        'h2': {
          width: '100%',
        },
        '.item': {
          width: '100%',
          border: 'none',
        },
        '.panel': {
          paddingBotton: '4px',
          //  width: '100%',
        },
        '.accordionButton': {
          width: '100%',
          padding: '0',
          justifyContent: 'space-between',
          color: '#000',
          backgroundColor: '#D7DDE8',
        },
        '.accordionPanel': {
          position: 'relative',
          display: 'flex',
          justifyContent: 'space-between',
          backgroundColor: '#F7F7FA',
          padding: '.5rem 0 2rem 0',

        },
        '.previewWrapper': {
          width: '100%',
        },
        '.icon': {
          border: 'none !important',
          marginRight: '1rem',
          fontWeight: 'bold',
          width: '2rem !important',
          height: '2rem !important',
          color: '#000',
          paddingRight: '.5rem',

        },
        '.heading': {
          width: '100%',

        },

        '.editButton': {
          position: 'absolute',
          bottom: '-3rem',
          height: 'auto',
          width: 'fit-content !important',
          padding: '.3rem 2rem  !important',
          backgroundColor: '#FF914D !important',
          right: '0',
        },
      },
      whiteBox: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: '#F7F7FA',
        padding: '.5rem 0 2rem 0',
        marginBottom: '1rem',
        '.divider': {
          padding: '.5rem 0',
          borderBottom: '1px solid #333',
          width: '100%',
          _last: { borderBottom: 'none' },
        },
        '.date': {
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
        },


      },
      work: {
        display: 'flex',
        justifyContent: 'space-between',
        w: '100%',
        p: '10px',
      },
      sidebar: {
        '.sidebarButton': {
          color: '#fff',
          backgroundColor: '#CC1F88 !important',

          _hover: {
            //background: '#D7DDE8 !important',
          },
        },
        '.panelInterior': {
          padding: '0 0 1rem 0 !important',
          backgroundColor: '#F7F7FA',
          border: '1px solid transparent',
          borderRadius: '10px !important',
        },
        '.panelPadding': {
          padding: '0 1.2rem',
        },
        '.sidebarSectionTitle': {
          color: '#fff !important',
          background: '#CC1F88 !important',
        },
        '.emptySection': {
          color: '#333',
          borderBottom: '1px solid white',
          padding: '.5rem 0',
          _last: { borderBottom: 'none' },
        },
        'a': {
          textDecoration: 'underline',
        },
        '.sidebarIcon': {
          color: '#fff !important',
        },
        '.template': {
          textAlign: 'center',
          padding: '.5rem 1rem .5rem 1rem',
          backgroundColor: '#F7F7FA',
        },
        '.borderBox': {
          borderRadius: '10px',
        },

        '.content': {
          margin: '1rem 0',
        },
        '.contentText': {
          fontWeight: 'bold',
          fontSize: '22px',
          textAlign: 'center',
        },
        '.sideEditButton': {
          background: '#CC1F88 !important',
          width: 'fit-content !important',
          color: 'white',
          padding: '.2rem 1rem !important',
          height: 'auto',
        },
      },
    },
  },
};

